// extracted by mini-css-extract-plugin
export default {"subtitles":"subtitles__067Sn"};